import type { RecordItem } from '#/common/components/RecordPreview';

export interface AssetPlanSummaryRecord {
  name?: string | null;
  startYear?: number | null;
  endYear?: number | null;
  draftStatus?: string | null;
  notes?: string | null;
}

const GRID_QUARTER = { xs: 6, sm: 6, md: 3, lg: 3 };
const GRID_FULL = { xs: 12, sm: 12, md: 12, lg: 12 };

export const fields: RecordItem<AssetPlanSummaryRecord>[] = [
  {
    items: [
      {
        dataField: 'name',
        label: 'Title',
        dataType: 'string',
        gridOptions: GRID_QUARTER,
      },
      {
        dataField: 'startYear',
        label: 'Start Year',
        dataType: 'number',
        gridOptions: GRID_QUARTER,
      },
      {
        dataField: 'endYear',
        label: 'End Year',
        dataType: 'number',
        gridOptions: GRID_QUARTER,
      },
      {
        dataField: 'draftStatus',
        label: 'Status',
        dataType: 'string',
        gridOptions: GRID_QUARTER,
      },
    ],
  },
  {
    items: [
      {
        dataField: 'notes',
        label: 'Description',
        dataType: 'string',
        gridOptions: GRID_FULL,
      },
    ],
  },
];
